// import {
//   getContentHomepage,
//   postContentHomepage,
// } from '@/src/request/salesChannel/content';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { IParams } from 'src/pages/SalesChannelContentEditor/common';
//import RouteBlock from './RouteBlock';
//import { SALES_CHANNELS_MULTI_LANG_PROPS } from 'src/tools/constant';
import {
  useSalesChannelType,
  useSalesChannel,
} from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { currentSelectedSize } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewSizeContainer/slice';
import { currentSelectedStyle } from 'src/constrains/SalesChannelStyleSelect/slice';
import { ChannelType, WebSiteSubType } from 'src/types/common/SalesChannel';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { SalesChannelContentStatus } from '@/src/types/common/common';
import {
  salesChannelResourceNameGenerator,
  isUserValid,
} from 'src/tools/getUserInfo';
import {
  EnumCategory,
  EnumSubCategory,
  EnumOperation,
  EPermissionSource,
} from 'src/types/common/resources';
import { currentSelectedLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';

const useSalesChannelContent = () => {
  const isInPrimaryLanguage = isCurrentPrimary();
  const params: IParams = useParams();
  // const { contentUuid, saleChannelUuid } = params;
  const type = useSalesChannelType();
  const salesChannel = useSalesChannel();
  const status = get(salesChannel, 'status');
  const uuid = get(salesChannel, 'salesChannelUuid');
  const selectedLanguage = useSelector(currentSelectedLanguage());

  const canSave = () => {
    if (
      status === SalesChannelContentStatus.Live ||
      status === SalesChannelContentStatus.Scheduled
    ) {
      return isUserValid({
        source: EPermissionSource.salesChannel,
        resourcesGroup: [
          salesChannelResourceNameGenerator({
            category: EnumCategory.SalesChannelContent,
            subCategory: EnumSubCategory.ChannelContent,
            operation: EnumOperation.create_duplicate_edit_live_content_version,
            uuid,
          }),
        ],
      });
    }
    if (status === SalesChannelContentStatus.Draft) {
      return isUserValid({
        source: EPermissionSource.salesChannel,
        resourcesGroup: [
          salesChannelResourceNameGenerator({
            category: EnumCategory.SalesChannelContent,
            subCategory: EnumSubCategory.ChannelContent,
            operation:
              EnumOperation.create_duplicate_edit_draft_content_version,
            uuid,
          }),
        ],
      });
    }
    return true;
  };
  const isNotMini = type !== ChannelType.MiniProgram;
  const salesChannelMultiLanguageParams = {
    [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
    [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
    ...(isNotMini
      ? {
          [EnumSalesChannelMultiLanguage.siteStyleInParams]: true,
          [EnumSalesChannelMultiLanguage.siteStyleForceUpdate]: true,
        }
      : {}),
    ...(isNotMini
      ? { [EnumSalesChannelMultiLanguage.siteStyleSizeInParams]: true }
      : {}),
  };

  const salesChannelMultiLanguageQueryParams = {
    [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
    ...(isNotMini
      ? {
          [EnumSalesChannelMultiLanguage.siteStyleInParams]: true,
        }
      : {}),
    ...(isNotMini
      ? { [EnumSalesChannelMultiLanguage.siteStyleSizeInParams]: true }
      : {}),
    //  salesChannelMultiLanguageUpdate: true,
  };
  // const multiProps = props[SALES_CHANNELS_MULTI_LANG_PROPS];
  // useGetPageLanguageList(multiProps);
  const currentLanguage = useQueryLanguageListContentEditor();
  const currentStyle = isNotMini
    ? useSelector(currentSelectedStyle())
    : WebSiteSubType.NativeMobile;

  const currentSize = useSelector(currentSelectedSize());
  return {
    isInPrimaryLanguage,
    params,
    salesChannel,
    salesChannelMultiLanguageParams,
    salesChannelMultiLanguageQueryParams,
    currentLanguage,
    currentStyle,
    currentSize,
    canSave: canSave(),
    selectedLanguage,
  };
};
export { useSalesChannelContent };
